const comments = [
  {
    name: '电影爱好者小王',
    text: '91在线视频真是我的观影宝库！精选推荐的质量太高了，每次都能发现好片。高清播放流畅不卡，比在其他平台找资源方便太多了。',
    tag: '资深用户',
    time: '2天前',
  },
  {
    name: '追剧达人Lily',
    text: '专题合集这个功能太贴心了，按主题分类想看的片子一目了然。悬疑烧脑那个专题我把里面的片子全看完了，每一部都精彩！',
    tag: '活跃用户',
    time: '3天前',
  },
  {
    name: '老电影收藏家',
    text: '能找到很多冷门经典的高清修复版，这点特别感动。91精品视频在线的片库质量对得起"精品"两个字，推荐给所有喜欢电影的朋友。',
    tag: '新用户',
    time: '5天前',
  },
  {
    name: '深夜观影人阿杰',
    text: '每晚睡前都要来逛逛热门榜单，看看有什么新上的高分电影。移动客户端体验也很好，躺床上用手机看画质依然清晰。',
    tag: '忠实粉丝',
    time: '1周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            用户评价
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            听听91在线视频的用户们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {comments.slice(0, 4).map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-700 text-sm font-heading font-semibold">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
                <span className="ml-auto inline-block px-2.5 py-0.5 rounded-full text-xs bg-accent-100 text-accent-700 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="flex gap-0.5 mb-2">
                {[1, 2, 3, 4, 5].map((s) => (
                  <i key={s} className="ri-star-fill text-accent-500 text-xs"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}